import {
  SET_ALERT_ERROR,
  SET_ALERT_SUCCESS,
  RESET_ALERT,
} from "../../constants/actionTypes";
import {
  getUniqueErrorMessages,
  getUniqueErrorMessagesArray,
} from "../../utils";
import _ from "lodash";

const setAlertError = (error) => {
  return {
    type: SET_ALERT_ERROR,
    payload: error,
  };
};

const setImportFileAlertError = (response) => {
  const errorItems = [];
  if (!_.isEmpty(response.error_message)) {
    errorItems.push(response.error_message);
  }
  if (!_.isEmpty(response.errors)) {
    response.errors.forEach((item) => {
      let message = `• 行 ${item.row} : ${item.message}`;
      errorItems.push(message);
    });
  }
  return {
    type: SET_ALERT_ERROR,
    payload: errorItems,
  };
};

const setUpdateUserBatchAlertError = (response) => {
  const errorItems = [];
  if (!_.isEmpty(response.error_message)) {
    errorItems.push(response.error_message);
  }
  if (!_.isEmpty(response.errors)) {
    const uniqueErrorMessages = getUniqueErrorMessages(response.errors);
    uniqueErrorMessages.forEach((error_message, index) => {
      let message = `• ${error_message}`;
      errorItems.push(message);
    });
  }
  return {
    type: SET_ALERT_ERROR,
    payload: errorItems,
  };
};

const setRegisterInspectionAlertError = (response) => {
  const errorItems = [];
  if (!_.isEmpty(response.error_message)) {
    errorItems.push(response.error_message);
  }
  if (!_.isEmpty(response.errors)) {
    const uniqueErrorMessages = getUniqueErrorMessagesArray(response.errors);
    uniqueErrorMessages.forEach((error_message, index) => {
      let message = `• ${error_message}`;
      errorItems.push(message);
    });
  }
  return {
    type: SET_ALERT_ERROR,
    payload: errorItems,
  };
};

const setUpdateMachineBatchAlertError = (response) => {
  const errorItems = [];
  if (!_.isEmpty(response.error_message)) {
    errorItems.push(response.error_message);
  }
  if (!_.isEmpty(response.errors)) {
    const errors = response.errors;
    for (const key in errors) {
      const error = `• ${errors[key]}`;
      if (!errorItems.includes(error)) {
        errorItems.push(error);
      }
    }
  }
  return {
    type: SET_ALERT_ERROR,
    payload: errorItems,
  };
};

const setHistorySearchAlertError = (response) => {
  const errorItems = [];
  if (!_.isEmpty(response.error_message)) {
    errorItems.push(response.error_message);
  }
  if (!_.isEmpty(response.errors)) {
    for (const key in response.errors) {
      errorItems.push(`• ${response.errors[key]}`);
    }
  }
  return {
    type: SET_ALERT_ERROR,
    payload: errorItems,
  };
};

const setInspectionConfirmAlertError = (response) => {
  const errorItems = [];
  if (!_.isEmpty(response.errors)) {
    for (const key in response.errors) {
      errorItems.push(response.errors[key]);
    }
  }
  return {
    type: SET_ALERT_ERROR,
    payload: errorItems,
  };
};

const setAlertErrorWorkflowDetails = (response) => {
  const errorItems = [];
  if (!_.isEmpty(response.error_message)) {
    errorItems.push(response.error_message);
  }
  if (!_.isEmpty(response.errors)) {
    for (const key in response.errors) {
      if (key.startsWith("template_") || key.startsWith("name")) {
        continue;
      }
      const error_message = `• ${response.errors[key]}`;
      if (!errorItems.includes(error_message)) {
        errorItems.push(error_message);
      }
    }
  }
  return {
    type: SET_ALERT_ERROR,
    payload: errorItems,
  };
};

const setAlertSuccess = (success) => {
  return {
    type: SET_ALERT_SUCCESS,
    payload: success,
  };
};

const resetAlert = () => {
  return {
    type: RESET_ALERT,
    payload: null,
  };
};

export {
  setAlertError,
  setAlertSuccess,
  resetAlert,
  setImportFileAlertError,
  setUpdateUserBatchAlertError,
  setHistorySearchAlertError,
  setRegisterInspectionAlertError,
  setUpdateMachineBatchAlertError,
  setInspectionConfirmAlertError,
  setAlertErrorWorkflowDetails,
};
